export default "__VITE_ASSET__0757619f__"